__turbopack_context__.v({
  "content": "ManualBlok-module__Gm3hRW__content",
  "description": "ManualBlok-module__Gm3hRW__description",
  "icon": "ManualBlok-module__Gm3hRW__icon",
  "link": "ManualBlok-module__Gm3hRW__link",
  "root": "ManualBlok-module__Gm3hRW__root",
  "title": "ManualBlok-module__Gm3hRW__title",
});
